import { render, staticRenderFns } from "./DialogDetteView.vue?vue&type=template&id=e790a96e"
import script from "./DialogDetteView.vue?vue&type=script&lang=js"
export * from "./DialogDetteView.vue?vue&type=script&lang=js"
import style0 from "./DialogDetteView.vue?vue&type=style&index=0&id=e790a96e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports